module.exports = "/_next/static/images/8e80546d430ea722124de70cabb7f7d7-phone-icon.svg.webp";